import React from 'react';

import { Container } from '@soluto-design/react';
import CardMediaLarge, {
    CardMediaLargeProps,
} from '../../molecules/CardMediaLarge';

export interface CardMediaLargeSectionProps extends CardMediaLargeProps {}

function CardMediaLargeSection(props: CardMediaLargeSectionProps) {
    return (
        <section className="mt-48 mb-gutter">
            <Container>
                <CardMediaLarge {...props} />
            </Container>
        </section>
    );
}

export default CardMediaLargeSection;
